import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { RfpClientListTitleSkeleton } from '@/components/modules/pages/mypage/client/Typography/Body/RfpClientListTitle';
import { FlatAccordion } from '@/components/ui/Accordion/FlatAccordion';
export const RfpClientTableSmallRowSkeleton = (props) => {
    const { className = '' } = props;
    return (_jsx("tr", { children: _jsx("td", { children: _jsx(FlatAccordion, { className: className, headComponent: _jsx(RfpClientListTitleSkeleton, {}), isOpen: false }) }) }));
};
